// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vdp-datepicker__calendar-button{position:absolute;right:15px;top:15px}", ""]);
// Exports
module.exports = exports;
